import { gsap } from 'gsap';
function Animate(
  sprite,
  {
    duration = 1,
    speed = 1,
    ease = 'power3.out',
    type,
    elementToAnimate,
    delayValue,
    direction,
    SubSceneContainer,
    Textsprite,
    isMask,
    TextBackgroundSprite,
    isBackground,
    textPartsArray,
    textBackgroundSpriteHeight,
    textBackgroundSpriteWidth,
    fullWidth,
  }
) {
  let animation;
  duration = duration * speed;
  let steps = elementToAnimate?.length || textPartsArray?.length || 1;
  var animX;
  var animY;
  switch (direction) {
    case 'up':
      animX = 0;
      animY = sprite.height || textBackgroundSpriteHeight;
      break;
    case 'down':
      animX = 0;
      animY = -sprite.height || textBackgroundSpriteHeight;
      break;
    case 'left':
      animX = sprite.width || textBackgroundSpriteWidth;
      animY = 0;
      break;
    case 'right':
      animX = -sprite.width || textBackgroundSpriteWidth;
      animY = 0;
      break;
  }
  if (type == 'entry') {
    if (isMask) {
      //sprite = sprite.clone();
      SubSceneContainer.addChild(sprite);
      let bgMasksprite = sprite.clone();
      Textsprite.mask = sprite;
      bgMasksprite.x = TextBackgroundSprite.x;
      bgMasksprite.y = TextBackgroundSprite.y;
      SubSceneContainer.addChild(bgMasksprite);
      TextBackgroundSprite.mask = bgMasksprite;
      animation = gsap.from(bgMasksprite, {
        pixi: {
          x: bgMasksprite.x + animX,
          y: bgMasksprite.y + animY,
        },
        duration: duration + 0.5 * duration,
        ease: 'power3.out',
        delay: delayValue,
        onComplete: () => {
          Textsprite.mask = undefined;
          TextBackgroundSprite.mask = undefined;
          SubSceneContainer.removeChild(bgMasksprite);
          SubSceneContainer.removeChild(sprite);
        },
        stagger: duration / steps,
      });
    } else if (!isBackground) {
      animation = gsap.from(elementToAnimate, {
        pixi: {
          x: (index, target) => calculateXCoord(index, target, direction),
          y: (index, target) => calculateYCoord(index, target, direction),
        },
        duration: duration,
        delay: delayValue,
        ease: ease,
        stagger: duration / steps,
      });
    }
  } else {
    if (isMask) {
      //sprite = sprite.clone();
      //SubSceneContainer.addChild(sprite);
      let bgMasksprite = sprite.clone();
      //Textsprite.mask = sprite;

      if (!TextBackgroundSprite.mask) {
        bgMasksprite.x = TextBackgroundSprite.x;
        bgMasksprite.y = TextBackgroundSprite.y;
        //SubSceneContainer.addChild(bgMasksprite);
        //TextBackgroundSprite.mask = bgMasksprite;
      } else {
        bgMasksprite = TextBackgroundSprite.mask;
      }
      animation = gsap.to(bgMasksprite, {
        pixi: {
          x: bgMasksprite.x + animX,
          y: bgMasksprite.y + animY,
        },
        delay: steps > 1 && delayValue > duration ? delayValue - duration : delayValue,
        duration: duration + 0.5 * duration,
        ease: 'power3.in',
        onStart: () => {
          SubSceneContainer.addChild(sprite);
          Textsprite.mask = sprite;
          if (!fullWidth) {
            SubSceneContainer.addChild(bgMasksprite);
            TextBackgroundSprite.mask = bgMasksprite;
          }
        },
        stagger: duration / steps,
      });
    } else if (!isBackground) {
      animation = gsap.to(elementToAnimate, {
        pixi: {
          x: (index, target) => calculateXCoord(index, target, direction),
          y: (index, target) => calculateYCoord(index, target, direction),
        },
        duration: duration,
        delay: steps > 1 && delayValue > duration ? delayValue - duration : delayValue,
        ease: 'power3.in',
        stagger: duration / steps,
      });
    }
  }
  return animation;
}

function calculateXCoord(index, target, direction) {
  var animX;
  let width = target.width;
  if (target?.style?.fontSize) {
    width = parseFloat(0.5 * target.style.fontSize.replace('px', ''));
  }
  switch (direction) {
    case 'up':
    case 'down':
      animX = 0;
      break;
    case 'left':
      animX = width;
      break;
    case 'right':
      animX = -width;
      break;
  }
  return target.x + animX;
}

function calculateYCoord(index, target, direction) {
  var animY;
  switch (direction) {
    case 'up':
      animY = target.height;
      break;
    case 'down':
      animY = -target.height - 10;
      break;
    case 'left':
    case 'right':
      animY = 0;
      break;
  }
  return target.y + animY;
}

export default { Animate };
